import { FailedStartupPage } from "./FailedStartupPage";

export const FailedStartup = () => {
	return <FailedStartupPage />;
};
